import {
    headerGeneralEventHandler,
    offsiteBrowserPushNotificationClick,
    offsiteBrowserPushNotificationImpression,
} from 'reaxl-analytics-handlers';

import paymentsDuck from '@/ducks/paymentsDuck.js';
import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import { compareListingsModalPageView } from './compareListingAnalyticsHandlers';
import { compareListingsClick } from './srp/srpSearchEvents';
import { snap360Click } from './vdp/snap360AnalyticHandlers';

export default {

    compareListingsClick: (metadata = {}, option) => {
        const { data, state } = metadata;

        const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);

        return compareListingsClick({
            ...metadata,
            data: {
                ...data,
                pixallData: {
                    ...data.pixallData,
                    filterValues,
                },
            },
        }, option);
    },

    compareListingsModalPageView: (metadata, ...arg) => {
        const { data, state } = metadata;

        const { pixallData } = data;
        const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);

        return compareListingsModalPageView({
            ...metadata,
            data: {
                ...data,
                pixallData: {
                    ...pixallData,
                    filterValues,
                },
            },
        }, ...arg);
    },

    headerGeneralEventHandler: (metadata = {}, option) => {
        const { data, state } = metadata;

        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return headerGeneralEventHandler({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory.id,
            },
        }, option);
    },

    offsiteBrowserPushNotificationClick: (metadata, option) => {
        const { data, state } = metadata;
        const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

        return offsiteBrowserPushNotificationClick({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory.id,
                filterValues,
            },
            paymentsDuck,
        }, option);
    },

    offsiteBrowserPushNotificationImpression: (metadata, option) => {
        const { data, state } = metadata;
        const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return offsiteBrowserPushNotificationImpression({
            ...metadata,
            data: {
                ...data,
                filterValues,
                inventoryId: activeInventory.id,
            },
            paymentsDuck,
        }, option);
    },

    snap360Click: (metadata = {}, option) => {
        const { data, state } = metadata;
        const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
        return snap360Click({
            ...metadata,
            data: {
                ...data,
                inventoryId: activeInventory.id,
            },
        }, option);
    },
};
